window.isFlutterInAppWebViewReady = window.isFlutterInAppWebViewReady || false

class AddToCart extends HTMLElement {
  constructor() {
    super();
  }
  addToCartVariant(variantId) {
    console.log("Stikky ATC")
    const that = this;
    that.classList.add("loading");

    const payload = {
        action: "addToCart",
        data: {
          variantId: `gid://shopify/ProductVariant/${variantId}`,
          quantity: 1
        }
    };
    if(!window.isFlutterInAppWebViewReady){
      console.warn("Flutter not ready yet.")
      return 
    }
    window.flutter_inappwebview.callHandler('Stikky', payload);

    // fetch(window.Shopify.routes.root + "cart/add.js", {
    //   method: "POST",
    //   credentials: "same-origin",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     items: [
    //       {
    //         id: variantId,
    //         quantity: 1,
    //       },
    //     ],
    //     sections: ["cart-drawer", "cart-main"],
    //   }),
    // })
    // .then((response) => {
    //   return response.json();
    // })
    // .then((response) => {
    //   if (response.status) {
    //     const error_string = `\nCART GET FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
    //     throw new Error(error_string, { cause: "Cart Error" });
    //   } else {
    //     that.classList.remove("loading");
    //     window.dispatchEvent(
    //       new CustomEvent("cart:add", {
    //         detail: {
    //           ...response,
    //           added_count: 1,
    //         },
    //       }),
    //     );
    //   }
    // })
    // .catch((error) => {
    //   that.classList.remove("loading");
    //   console.error(error);
    // });
  }
  getUniqueId(){
    let firstPart = (Math.random() * 46656) | 0;
    let secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
  }
  addToCart(form) {
    const that = this;
    const uniqeID = that.getUniqueId();
    const uniqueInputs = form.querySelectorAll('input[data-value-unique]');
    uniqueInputs.forEach(input => {
      let setMini = false;
      if(input.value?.includes('_mini')){
          setMini = true;
      }
      input.value = uniqeID;
      if(setMini){
        input.value = `${input.value}_mini`;
      }
    });
    const formData = new FormData(form);
    const components = [];
    if(formData.get('add_type') === 'bundle') {
      const formDataEntries = Array.from(formData.entries());
      const component_variant_ids = formDataEntries.filter(entry => entry[0].includes('items[') && entry[0].includes(']id')).map(entry => entry[1]);
      const component_product_ids = formDataEntries.filter(entry => entry[0].includes('items[') && entry[0].includes(']product_id')).map(entry => entry[1]);
      const component_amounts = formDataEntries.filter(entry => entry[0].includes('items[') && entry[0].includes(']amount')).map(entry => entry[1]);
      const component_quantities = formDataEntries.filter(entry => entry[0].includes('items[') && entry[0].includes(']quantity')).map(entry => entry[1]);
      component_variant_ids.forEach((variant_id, index) => {
        const component = {
          variant_id: variant_id,
          product_id: component_product_ids[index],
          amount: component_amounts[index],
          quantity: component_quantities[index],
        } 
        components.push(component);
      })
    }
    formData.append("sections", ["cart-drawer", "cart-main"]);
    that.classList.add("loading");
    // Todo: Add properties
    const payload = {
        action: "addToCart",
        data: {
          variantId: `gid://shopify/ProductVariant/${formData.get('id')}`,
          quantity: 1
        }
    };

    if(!window.isFlutterInAppWebViewReady){
      console.warn("Flutter not ready yet.")
      return 
    }

    window.flutter_inappwebview.callHandler('Stikky', payload);

    // fetch(window.Shopify.routes.root + "cart/add.js", {
    //   method: "POST",
    //   credentials: "same-origin",
    //   body: formData,
    // })
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((response) => {
    //     if (response.status) {
    //       const error_string = `\nCART GET FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
    //       throw new Error(error_string, { cause: "Cart Error" });
    //     } else {
    //       that.classList.remove("loading");
    //       window.dispatchEvent(
    //         new CustomEvent("cart:add", {
    //           detail: {
    //             ...response,
    //             add_type: formData.get('add_type') === 'bundle' ? 'bundle' : 'single',
    //             components: components,
    //             added_count: Number(formData.get("quantity")) || 1,
    //           },
    //         }),
    //       );
    //     }
    //   })
    //   .catch((error) => {
    //     that.classList.remove("loading");
    //     console.error(error);
    //   });
  }
  connectedCallback() {
    const variantId = this.getAttribute("variant-id") || null;
    if (!!variantId) {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const disabled = this.hasAttribute("disabled") && this.getAttribute("disabled") !== "false";
        if (!disabled) {
          this.addToCartVariant(Number(variantId));
        }
      });
      return;
    }

    const form = this.closest("form");
    if (!!form) {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const disabled = this.hasAttribute("disabled") && this.getAttribute("disabled") !== "false";
        if (!disabled) {
          this.addToCart(form);
        }
      });
    }
  }
}

customElements.define("add-to-cart", AddToCart);
